









































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { AuthModule } from '@/app/store/modules/auth'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
@Component
export default class LoginScreen extends Vue {
  public $v: Vuelidate
  public formatEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
    email,
  })
  public email = ''
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public password = ''
  public passwordType = 'password'
  public iconType = 'eye'

  public get isDisabled(): boolean {
    return AuthModule.isLoading
  }

  public testClick() {
    if (this.passwordType === 'password' && this.iconType === 'eye') {
      this.passwordType = 'text'
      this.iconType = 'eye-slash'
    } else {
      this.passwordType = 'password'
      this.iconType = 'eye'
    }
  }
  public async buttonLogin() {
    this.$v.email.$touch()
    this.$v.password.$touch()
    if (this.$v.email.$invalid || this.$v.password.$invalid) {
      return
    } else {
      await AuthModule.sendLogin({ email: this.email, password: this.password })
    }
  }

  public get stateEmail(): boolean {
    const regex = new RegExp(this.formatEmail)
    const valid = regex.test(this.email)
    return valid === true ? true : false
  }

  public get statePassword(): boolean {
    return this.password.length > 6 ? true : false
  }

  public get invalidEmail(): string {
    const regex = new RegExp(this.formatEmail)
    const valid = regex.test(this.email)
    if (this.email.length === 0) {
      return 'Email can`t be Empty'
    } else if (this.email.length > 0 && valid === false) {
      return 'Invalid Email Format'
    } else {
      return ''
    }
  }

  public get invalidPassword(): string {
    if (this.password.length === 0) {
      return 'Password can`t be Empty'
    } else if (this.password.length < 6) {
      return 'Password must be 6 characters'
    } else {
      return ''
    }
  }

  public get validEmail(): string {
    return this.stateEmail === true ? '' : ''
  }

  public get validPassword(): string {
    return this.statePassword === true ? '' : ''
  }
}
